import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { useGameStore } from '@/stores/game';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
  },
  {
    path: '/market',
    name: 'market',
    component: () => import('@/views/BlackMarketView.vue'),
  },
  {
    path: '/bank',
    name: 'bank',
    component: () => import('@/views/BankingView.vue'),
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: () => import('@/views/CryptoExchangeView.vue'),
  },
  {
    path: '/combat',
    name: 'combat',
    component: () => import('@/views/AttackConsoleView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard',
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  const game = useGameStore();
  if (!to.meta.public && !game.isAuthenticated) {
    // Remember where the user wanted to go so we can return after login.
    next({ name: 'login', query: { redirect: to.fullPath } });
  } else if (to.name === 'login' && game.isAuthenticated) {
    next({ name: 'dashboard' });
  } else {
    next();
  }
});
